export default {
  blackLists: (state) => {
    return state.blackLists;
  },
  
  saleManagerDiscountLimits: (state) => {
    return state.saleManagerDiscountLimits;
  },

  saleManagerCredits: (state) => {
    return state.saleManagerCredits;
  },

  ordrSettings: (state) => {
    return state.ordrSettings;
  },

  orders: (state) => {
    return state.orders;
  },
  orderById: (state) => {
    return state.orderById;
  },
  orderMaxCode: (state) => {
    return state.orderMaxCode;
  },

  orderCartable: (state) => {
    return state.orderCartable;
  },

  orderManagementCartable: (state) => {
    return state.orderManagementCartable;
  },

  settlementTypes: (state) => {
    return state.settlementTypes;
  },

  printLink: (state) => {
    return state.printLink;
  },
};
